/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_SettingsInputs */

const en_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Settings`)
};

const fr_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour`)
};

const de_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen aktualisieren`)
};

const it_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna impostazioni`)
};

const ru_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить настройки`)
};

const es_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar configuración`)
};

const zh_cn2_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新设置`)
};

const ja_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を更新`)
};

const hi_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स अपडेट करें`)
};

const pt_pt2_update_settings = /** @type {(inputs: Update_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar configurações`)
};

/**
* | output |
* | --- |
* | "Update Settings" |
*
* @param {Update_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_settings = /** @type {((inputs?: Update_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_settings(inputs)
	if (locale === "de") return de_update_settings(inputs)
	if (locale === "it") return it_update_settings(inputs)
	if (locale === "ru") return ru_update_settings(inputs)
	if (locale === "es") return es_update_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_update_settings(inputs)
	if (locale === "ja") return ja_update_settings(inputs)
	if (locale === "hi") return hi_update_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_update_settings(inputs)
	return en_update_settings(inputs)
});